import { render, staticRenderFns } from "./AddAccountIdent.vue?vue&type=template&id=259004b2&scoped=true&"
import script from "./AddAccountIdent.vue?vue&type=script&lang=js&"
export * from "./AddAccountIdent.vue?vue&type=script&lang=js&"
import style0 from "./AddAccountIdent.vue?vue&type=style&index=0&id=259004b2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259004b2",
  null
  
)

export default component.exports